/* eslint-disable @typescript-eslint/no-unused-vars */
import store from '../redux/store';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/fr';
import 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
dayjs.locale('fr');
dayjs.extend(relativeTime);

export default {
  loginUsers: (data) => data,
  authentificationUser(res, data, getState) {
    if (!res || !res.data) {
      return {error: res};
    }
    //const user = getState && getState() ? getState().user : {};
    return {...res};
  },
  inscriptionUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let storedUser = {};
    if (!res || !res.data) {
      return {error: true};
    }

    if (!res.data.data) {
      storedUser = {
        ...users,
        data: {
          ...users.data,
          utilisateur: {...users.data.utilisateur, ...res.data},
        },
      };
    } else {
      storedUser = {...res.data};
    }
    return storedUser;
  },
  signOutUser(res, data, getState) {
    return {data: {}};
  },
  disconnectedUser(res, data, getState) {
    return {data: {}};
  },
  motCleUser(res, data, geState) {
    const users = store.getState() ? store.getState().user : {};
    let storeMot = {};
    if (res && res.data) {
      storeMot = {...users, motCle: res.data};
    } else {
      return {error: true};
    }
    return storeMot;
  },
  notificationUser(res, data, geState) {
    const users = store.getState() ? store.getState().user : {};
    let listNotificationUser = store.getState().user.listNotificationMobile
      ? store.getState().user.listNotificationMobile
      : [];
    let notification = {};
    if (res && res.data && res.data.items) {
      let listNotification = res.data.items.map((e) => {
        return {
          id: e.id,
          titre: e.titre,
          message: e.message,
          vu: e.vu,
          dateCreation: dayjs(e.dateCreation).fromNow(),
        };
      });
      notification = {
        ...users,
        listNotification: listNotification,
        listNotificationMobile: [...listNotificationUser, ...listNotification],
        totalNotification: res.data.totalCount,
      };
    } else {
      return {error: true};
    }
    return notification;
  },
  notificationNotSeenUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let notification = {};
    if (res) {
      notification = {...users, numberNotificationNotSeen: res.data};
    } else {
      return {error: true};
    }
    return notification;
  },
  initialNotificationUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let initialNotification = {};
    if (res) {
      initialNotification = {...users, listNotificationMobile: []};
    } else {
      return {error: true};
    }
    return initialNotification;
  },
  notificationVuUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let notification = {};
    if (res) {
      notification = {...users, vuNotif: res};
    } else {
      return {error: true};
    }
    return notification;
  },
  politiqueConfidentialite(res, data, geState) {
    const confidentialite = store.getState()
      ? store.getState().confidentialite
      : '';
    let politiqueDonnee = {};
    if (res) {
      politiqueDonnee = {...confidentialite, etat: res};
    } else {
      return {error: true};
    }
    return politiqueDonnee;
  },
  flowSouscriptionVoyage(res, data, geState) {
    const flowVoyage = store.getState()
      ? store.getState().flowVoyage
      : '';
    let voyageDonnee = {};
    if (res) {
      voyageDonnee = {...flowVoyage, etat: res};
    } else {
      return {error: true};
    }
    return voyageDonnee;
  },
  initialRouteUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let initialRoute = {};
    if (res) {
      initialRoute = {...users, initialRoute: res};
    } else {
      return {error: true};
    }
    return initialRoute;
  },
  getNumeroPoliceUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};

    let numeroPolice = {};
    if (res.length > 0) {
      numeroPolice = {...users, numeroPolice: res};
    } else if (res === '') {
      numeroPolice = {...users, numeroPolice: ''};
    } else {
      numeroPolice = {...users, numeroPolice: ''};

      return numeroPolice;
    }

    return numeroPolice;
  },
  checkOrangeTransactionUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let orangeTranscation = {};
    if (res) {
      orangeTranscation = {...users, checkOrangeTransaction: res};
    } else {
      return {error: true};
    }
    return orangeTranscation;
  },
  checkTelmaTransactionUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let telmaTranscation = {};
    if (res) {
      telmaTranscation = {...users, checkTelmaTransaction: res};
    } else {
      return {error: true};
    }
    return telmaTranscation;
  },
  sinistreUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let sinistre = {};
    if (res) {
      sinistre = {...users, listSinistre: res};
    } else {
      return {error: true};
    }
    return sinistre;
  },
  modeVersementUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let versement = {};
    if (res) {
      versement = {...users, versement: res};
    } else {
      return {error: true};
    }
    return versement;
  },
  airtelmoneyUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let airtelResponse = {};
    if (res) {
      airtelResponse = {...users, airtelResponse: res};
    } else {
      return {error: true};
    }
    return airtelResponse;
  },
  airtelmoneyTransactionUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let airtelTransactionResponse = {};
    if (res) {
      airtelTransactionResponse = {...users, airtelTransactionResponse: res};
    } else {
      return {error: true};
    }
    return airtelTransactionResponse;
  },
  contratEnCoursUser(contratEC, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    if (contratEC) {
      var res = {...users, contratEC};
    } else {
      return {error: true};
    }
    return res;
  },
  orangemoneyUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let orangeResponse = {};
    if (res) {
      orangeResponse = {...users, orangeResponse: res};
    } else {
      return {error: true};
    }
    return orangeResponse;
  },
  orangemoneyTransactionUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let orangeTransactionResponse = {};
    if (res) {
      orangeTransactionResponse = {...users, orangeTransactionResponse: res};
    } else {
      return {error: true};
    }
    return orangeTransactionResponse;
  },
  mvolaUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let mvolaResponse = {};
    if (res) {
      mvolaResponse = {...users, mvolaResponse: res};
    } else {
      return {error: true};
    }
    return mvolaResponse;
  },
  mvolaTransactionUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let mvolaTranscationResponse = {};
    if (res) {
      mvolaTranscationResponse = {...users, mvolaTranscationResponse: res};
    } else {
      return {error: true};
    }
    return mvolaTranscationResponse;
  },
  cbTransactionUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let cbTransactionResponse = {};
    if (res) {
      cbTransactionResponse = {...users, cbTransactionResponse: res};
    } else {
      return {error: true};
    }
    return cbTransactionResponse;
  },

  historiquePaiementUser(res, data, getState) {
    const users = store.getState() ? store.getState().user : {};
    let historiquePaiement = {};
    if (res && res.data) {
      let listPaiementFormat = res.data.map((e) => {
        return {
          montant: e.montant,
          motif: e.motif,
          modePaiement: e.modePaiement,
          reference: e.reference,
          statut: e.statut,
          dateCreation: dayjs(e.dateCreation).format('DD/MM/YYYY - HH:mm'),
        };
      });
      historiquePaiement = {...users, listPaiement: listPaiementFormat};
    } else {
      return {error: true};
    }
    return historiquePaiement;
  },
};
